module.exports = {};



//////////////////
// WEBPACK FOOTER
// /home/ig_comp_doc/sandbox-manager-v3/node_modules/core-js/modules/_iterators.js
// module id = 134
// module chunks = 0